import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import columns from './columns';

const namespaced = true;

const state = {
  teachers: [],
  teacherProfile: null,
  filterByOrg: null,
  filterByLanguage: null,
  no_availability: false,
  no_availability_3week: false,
  active: null,
  is_coach: null,
  availabilityFilter: {
    no_availability: {
      label: 'Show only tutors with 0 availability',
      value: false,
    },
    no_availability_3week: {
      label: 'Show tutors with 0 availability at week 3',
      value: false,
    },
  },
  searchKeywords: '',
  count: 0,
  columns,
  currentPage: 0,
  lastRefreshDate: null,
  ordering: null,
  pageSize: 15,
};

export default {
  namespaced,
  actions,
  mutations,
  getters,
  state,
};
